import { render, staticRenderFns } from "./IconStickerTab.vue?vue&type=template&id=3dbac48c"
import script from "./IconStickerTab.vue?vue&type=script&lang=js"
export * from "./IconStickerTab.vue?vue&type=script&lang=js"
import style0 from "./IconStickerTab.vue?vue&type=style&index=0&id=3dbac48c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports